import React from 'react'
import { openEvolutionModal, responseData } from 'Pages/AnalyzersV2/@signals'
import { TourOverlay as BaseTourOverlay, default as VirtualTourButton } from 'Pages/Main/Home/VirtualTour'
import { TOUR_STEPS } from './steps'

// Used for back/dot navigation: re-opens evolution modal when jumping into step 5
const openEvolutionForTour = () => {
	if (Object.keys(responseData.value || {}).length > 0) {
		// Click a real cell — in Rating, cells open evolution directly (no popover)
		const rows = document.querySelectorAll('table tbody tr')
		for (const row of rows) {
			const cells = row.querySelectorAll('td')
			if (cells.length > 1) {
				const box = cells[1].querySelector('.MuiBox-root')
				if (box) { box.click(); break }
			}
		}
	} else {
		openEvolutionModal.value = { demoMode: true }
	}
}

const MODAL_RANGES = [
	{
		from: 5, to: 5,
		open: openEvolutionForTour,
		close: () => { openEvolutionModal.value = {} },
		isOpen: () => Object.keys(openEvolutionModal.value).length > 0
			&& !!document.querySelector('.MuiDialog-paperFullScreen'),
	},
]

export function TourOverlay(props) {
	return <BaseTourOverlay {...props} modalRanges={MODAL_RANGES} />
}

export { TOUR_STEPS }
export default VirtualTourButton
